module.exports = __webpack_public_path__ + "img/blanket_8.d2b8dfcd.png";